import {
  FETCH_MEMBERSHIP_TIERS_REQUEST,
  FETCH_MEMBERSHIP_TIERS_SUCCESS,
  FETCH_MEMBERSHIP_TIERS_FAILURE,
} from "../actions/membershipApplicationActionTypes";

import {
  ADD_MEMBERSHIP_TIER_REQUEST,
  ADD_MEMBERSHIP_TIER_SUCCESS,
  ADD_MEMBERSHIP_TIER_FAILURE,
  UPDATE_MEMBERSHIP_TIER_REQUEST,
  UPDATE_MEMBERSHIP_TIER_SUCCESS,
  UPDATE_MEMBERSHIP_TIER_FAILURE,
  CLEAR_MEMBERSHIP_TIER_ERROR,
} from "../actions/membershipTiersActionTypes";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const membershipTiersReducer = (state = initialState, action) => {
  switch (action.type) {
    // ===== Fetch Membership Tiers =====
    case FETCH_MEMBERSHIP_TIERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_MEMBERSHIP_TIERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_MEMBERSHIP_TIERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===== Add Membership Tier =====
    case ADD_MEMBERSHIP_TIER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_MEMBERSHIP_TIER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case ADD_MEMBERSHIP_TIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===== Update Membership Tier =====
    case UPDATE_MEMBERSHIP_TIER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_MEMBERSHIP_TIER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((tier) =>
          tier.id === action.payload.id ? action.payload : tier
        ),
        error: null,
      };
    case UPDATE_MEMBERSHIP_TIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===== Clear Error =====
    case CLEAR_MEMBERSHIP_TIER_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default membershipTiersReducer;
